import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, FormGroup } from 'semantic';
import { useTranslation } from 'react-i18next';
import { DropdownOption } from 'subdomains/cpo/screens/GroupsAndPolicies/types';
import { CustomerGroupModal } from '../../CustomerGroups/CustomerGroup/CustomerGroupModal';
import CardStyleRadioButton from 'components/form-fields/CardStyleRadioButton';

type Props = {
  values: string[];
  onChange?: (values: string[]) => void;
};

const CustomerGroupSelection: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(!props.values?.length);
  const [selectedCustomerGroups, setSelectedCustomerGroups] = useState<
    string[]
  >(props.values);

  // TODO: make more efficient
  useEffect(() => {
    if (isAllSelected) {
      props.onChange?.([]);
    } else if (selectedCustomerGroups.length > 0) {
      props.onChange?.(selectedCustomerGroups);
    }
  }, [isAllSelected, selectedCustomerGroups]);

  const handleModeChange = (isAll: boolean) => {
    if (isAll != isAllSelected) {
      setSelectedCustomerGroups([]);
    }

    setIsAllSelected(isAll);
  };

  // TODO: needs to become API req
  function getCustomerGroups(): DropdownOption[] {
    return [
      {
        key: 'CUSTOMER_GROUP_1',
        text: 'Customer group 1',
        value: 'CUSTOMER_GROUP_1',
      },
      {
        key: 'CUSTOMER_GROUP_2',
        text: 'Customer group 2',
        value: 'CUSTOMER_GROUP_2',
      },
    ];
  }

  return (
    <>
      <FormGroup style={{ marginLeft: '0', marginRight: '0' }}>
        <CardStyleRadioButton
          isSelected={isAllSelected}
          onClick={() => handleModeChange(true)}
          text={t(
            'chargingPolicy.pricing.customerGroupSelectionEveryone',
            'Everyone'
          )}
        />
        <CardStyleRadioButton
          isSelected={!isAllSelected}
          onClick={() => handleModeChange(false)}
          text={t(
            'chargingPolicy.pricing.customerGroupSelectionSpecific',
            'Customer Groups'
          )}
        />
      </FormGroup>
      {!isAllSelected && (
        <>
          <Form.Field required>
            <label>
              {t(
                'chargingPolicy.pricing.selectCustomerGroups',
                'Select Customer Groups'
              )}
            </label>
            <Dropdown
              selection
              multiple
              value={selectedCustomerGroups}
              options={getCustomerGroups()}
              onChange={(
                _: React.SyntheticEvent,
                { value }: { value: string[] }
              ) => setSelectedCustomerGroups(value)}
            />
          </Form.Field>
          <CustomerGroupModal
            // TODO: Load values into modal
            trigger={
              <Button
                basic
                icon="plus"
                style={{ marginLeft: '0' }}
                content={t(
                  'chargingPolicy.pricing.addCustomerGroup',
                  'New Customer Group'
                )}
              />
            }
            onSubmit={(newCustomerGroupId) => {
              // setFieldValue(buildFormPath('customerGroups', basePath), [
              //   ...(values?.customerGroups ?? []),
              //   newCustomerGroupId,
              // ]);
            }}
          />
        </>
      )}
    </>
  );
};

export default CustomerGroupSelection;
